export default {
  'validationModal.title': 'List of transactions',
};
